import { ButtonHTMLAttributes } from "react";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?:
    | "primary"
    | "secondary"
    | "outline"
    | "gold"
    | "none"
    | "gradient"
    | "noneBorder"
    | "lightGold"
    | "gray"
    | "agentGold"
    | "agentOutline"
    | "agentGhost";
  className?: string;
}

const Button = ({
  children,
  variant = "primary",
  className = "",
  ...props
}: ButtonProps) => {
  const baseStyles =
    "px-4 py-2 rounded-md font-medium transition-colors duration-200 ease-in-out cursor-pointer";

  const variantStyles = {
    primary: "bg-[#BBA473] text-black hover:bg-[#A68F5C]",
    secondary:
      "bg-[#1e1a10] text-[#E8D5A3] border border-[#BBA473]/30 hover:bg-[#241d10] hover:border-[#BBA473]/50",
    outline:
      "border border-[#BBA473]/40 text-[#E8D5A3] bg-transparent hover:bg-[#BBA473]/10",
    gold: "bg-gradient-to-r from-[#C6AF7C] to-[#A88F5F] text-black hover:brightness-105",
    none: "",
    gray: "text-[#9a9082] hover:text-[#BBA473] transition-colors duration-200",
    noneBorder:
      "absolute right-4 top-4 text-gray-400 hover:text-[#BBA473] transition-colors duration-200",
    lightGold:
      "bg-[#BBA473] hover:bg-[#A68F5C] text-black rounded hover:bg-[#A68F5C]",
    gradient:
      "block w-full text-[#E8D5A3] text-left py-2 px-3 hover:bg-[#BBA473]/15 hover:text-white cursor-pointer rounded transition-colors duration-200",

    // ── Sales Agent variants — matches AgentLoginPage / AgentSidebar palette ──
    agentGold:
      "bg-gradient-to-b from-[#DDB083] to-[#B87F4B] text-[#1C1006] font-semibold shadow-[0_4px_20px_rgba(184,127,75,0.25)] hover:shadow-[0_6px_28px_rgba(184,127,75,0.35)] hover:brightness-[1.03] active:scale-[0.985] disabled:cursor-not-allowed disabled:opacity-50 disabled:shadow-none",
    agentOutline:
      "border border-[#B87F4B]/30 text-[#D19A66] bg-transparent hover:bg-[#B87F4B]/10",
    agentGhost:
      "text-[#ADA79A] hover:text-[#F1EDE4] hover:bg-[#B87F4B]/08 bg-transparent",
  };

  return (
    <button
      className={`${variant !== "gradient" ? baseStyles : ""} ${variantStyles[variant]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
